const invertedMessages = {
  'External identities': 'external.dashboard.identities.externalIdentities',
  'External Identities based on classification rules':
    'external.dashboard.identities.count.tooltip',
  'This section presents the distribution of external identities based on employee type.':
    'external.dashboard.identities.info.tooltip',
};

export default invertedMessages;
